export const es = {
    // Login screen
    modal_login_capital: 'INICIAR SESIÓN',
    placeholder_email_address: 'correo electrónico',
    placeholder_password: 'contraseña',
    tooltip_forgot_password: '¿Has olvidado la contraseña?',
    log_in: 'Iniciar sesión',

    // Register screen
    modal_signup_capital: 'REGISTRARSE',
    placeholder_repeat_password: 'repetir contraseña',
    agree: 'Estoy de acuerdo con los ',
    terms: 'Términos',
    modal_register_capital: 'REGISTRO',
    full_name: 'Nombre completo',

    // Price options
    choose_price: 'ELIGE TU PRECIO',
    subscription_price: 'Suscripción',
    asset_price: 'Activo',
    paywall_subscription_text:
        'Puedes cancelar tu suscripción en cualquier momento.',
    modal_back: 'VOLVER',
    next_button: 'SIGUIENTE',

    // Payments screen
    pay: 'PAGAR',
    pay_with: 'PAGAR CON PAYPAL',
    credit_card: 'tarjeta de crédito',
    payment_pay: 'Pagar',
    payment_price: 'Precio',
    placeholder_voucher_code: 'código promocional',
    placeholder_voucher: 'añadir código',
    card_number: 'número de tarjeta',
    cardholder_name: 'nombre del titular de la tarjeta',

    // Forgot password
    forgot_pass_text:
        'Te enviaremos un correo electrónico con un enlace para restablecer tu contraseña.',
    remember_pass: '¿Recordar contraseña?',
    reset: 'RESTABLECER',

    // Set new password
    modal_enter_your_new_password: 'Introduce tu nueva contraseña.',
    modal_please_check_your_email:
        'Verifica tu correo electrónico y copia el autentificador para continuar.',
    placeholder_token: 'autentificador',
    new_password: 'nueva contraseña',
    repeat_new_password: 'repite la nueva contraseña',
    cancel: 'cancelar',
    set: 'ESTABLECER',

    // Change password
    update: 'actualizar',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Mi cuenta',
    member_since: 'Miembro desde',
    purchases: 'Mis compras',
    subscriptions: 'Mis suscripciones',
    account_details: 'Detalles de la cuenta',
    export_data: 'Exportar mis datos',
    delete_account: 'Borrar cuenta',

    // Purchases/Subscriptions
    purchases_link: 'Compras',
    subscriptions_link: 'Suscripciones',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Historial de compras',
    purchased: 'Comprado',
    name: 'nombre',
    active: 'activo',
    inactive: 'inactive',
    canceled: 'cancelado',
    type: 'Type',
    next_transaction: 'siguiente transacción',
    cancel_subscription: 'cancelar suscripción >',
    subscriptions_active: 'Activar suscripciones',
    expires_at: 'Caduca el',
    no_more_subscriptions: 'No hay más suscripciones.',
    no_available_subscriptions: 'No hay suscripciones disponibles.',
    no_more_active_accesses: 'No hay más accesos activos.',
    no_more_inactive_accesses: 'No hay más accesos inactivos.',
    no_available_active_accesses: 'No hay accesos activos disponibles.',
    no_available_inactive_accesses: 'No hay accesos inactivos disponibles.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question:
        '¿Estás seguro de que quieres exportar los datos de tu cuenta?',
    export: 'exportar',
    first_export:
        ' La acción de Exportar los Datos de la Cuenta exportará todos los datos personales de tu cuenta. Esto incluye lo siguiente:',
    second_export: 'Tu información personal',
    third_export: 'La lista de tus registros de inicio de sesión',
    fourth_export: 'La lista de tus suscripciones',
    fifth_export: 'La lista de tus pagos',
    sixth_export: 'La lista de tus accesos a contenido premium',
    last_export:
        'Los datos exportados se enviarán a tu dirección de correo electrónico como archivo adjunto.',

    // Delete account screen
    delete_question: '¿Estás seguro de que quieres eliminar tu cuenta?',
    delete: 'eliminar',
    confirm: "'CONFIRMAR",
    first_delete:
        'La acción de Eliminar la Cuenta eliminará todos tus datos personales del sistema. Esto incluye lo siguiente:',
    second_delete:
        'Información personal que proporcionaste durante el proceso de registro',
    third_delete:
        'Ubicación e información del dispositivo que recopilamos durante el proceso de autenticación',
    fourth_delete:
        'Toda otra información personal almacenada en otras partes de nuestra base de datos',
    fifth_delete:
        'La única información personal que conservaremos en el sistema es la que forma parte de los registros de transacciones y suscripciones debido a una legislación que debemos respetar.',
    sixth_delete:
        'Además de eliminar los datos, tu cuenta también se desactivará, lo que significa que todas tus suscripciones activas se cancelarán, todos tus accesos activos actuales a los activos serán revocados y todas tus sesiones de inicio de sesión activas, incluida esta, finalizarán. Ya no podrás autentificarte y comprar activos en este sitio web. La información de tu cuenta ya no estará disponible en ninguna lista para nuestro personal.',
    seventh_delete:
        'Esta acción puede tardar entre uno y dos días en completarse, después de lo cual se enviará un correo electrónico de confirmación a tu dirección de correo electrónico. El correo electrónico será borrado de nuestro sistema después de que se entregue con éxito.',

    // Inputs validation
    required_field: 'campo requerido',
    email_field: 'por favor, introduce un correo electrónico correcto',
    number_field: 'El valor debe ser un número',
    matchPass: 'a contraseña no coincide',
    minpass_field: 'debe contener al menos 8 caracteres',
    minname_field: 'debe contener al menos 2 caracteres',

    // Footer
    modal_terms: 'Términos',
    modal_privacy: 'Privacidad',
    modal_more: 'MAS',
    modal_faq: 'FAQ',
    modal_protected: '¿Qué es esto?',
    logout: 'Cerrar sesión',
    details: 'Mis detalles',
    preview_protected_by_inplayer: 'Protegido por',
    modal_support: 'Support',

    dlc_download: 'descargar',
};



// WEBPACK FOOTER //
// ./src/i18n/spanish.js